// extracted by mini-css-extract-plugin
export var originalPrice = "_v9-0";